import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'guestConfirmationStatusTag'
})
export class GuestConfirmationStatusTagPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case 'pending':
        return 'warn';
      case 'confirmed':
      case 'manage_delegate':
        return 'success';
      case 'rejected':
        return 'danger';
      case 'delegated':
        return 'info';
      case 'pending_approval':
        return 'contrast';
      default:
        return 'unknown';
    }
  }

}